/**
 * Created by quikr on 9/12/16.
 */
/**
 * Created by quikr on 8/16/16.
 */

const attendance = {
  "empId": 0,
  "name": " ",
  "avgInTime": "00:00:00",
  "avgOutTime": "00:00:00 ",
  "avgWorkHours": "0:00:00",
  "attendance": [{}
  ]

};
const attendanceRegularization = [];
const attendanceTeam = {"attendanceTeam": []};
const teamRegularisation = [];
const teamDetails = [{"attendance": []}];

export default function recruitReducer(state = [{attendance}, {attendanceRegularization}, {attendanceTeam}, {teamRegularisation}, {teamDetails}], action) {
  switch (action.type) {
    case 'GET_ATTENDANCE_SUCCESS':
      return [action.attendance, state[1], state[2], state[3], state[4]];
    case 'GET_REGULARISATION_SUCCESS':
      return [state[0], action.regularisation.regularisation, state[2], state[3], state[4]];
    case 'GET_TEAM_ATTENDANCE_SUCCESS':
      return [state[0], state[1], action.attendanceTeam, state[3], state[4]];
    case 'GET_TEAM_REGULARISATION_SUCCESS':
      return [state[0], state[1], state[2], action.teamRegularisation, state[4]];
    case 'GET_TEAM_DETAILS_SUCCESS':
      return [state[0], state[1], state[2], state[3], action.teamDetails];


    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/Attendance/attendanceReducer.js
 **/